import { useEffect, useState } from "react";
import { portalPackagesApi } from "../api/packages";

// Sender-Fields v1 — fetch the recipient's letter PDF (preview) as an object
// URL for an <iframe>. Shared by the pre-sign review surface (FormItemSurface
// letter branch) and the signing surface. The object URL is revoked on unmount
// / item change. Failure is non-fatal — the recipient can still sign.
export function useLetterPreview(itemId: string, enabled: boolean) {
  const [url, setUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    let objectUrl: string | null = null;
    setLoading(true);
    void (async () => {
      try {
        const blob = await portalPackagesApi.getLetterPreview(itemId);
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
        setError(null);
      } catch (e) {
        if (!cancelled) {
          setError(e instanceof Error ? e.message : "Couldn't load the document.");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [itemId, enabled]);

  return { url, error, loading };
}
